import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import {
    withStyles, Dialog, DialogContent, DialogActions, DialogTitle, Button,
    TextField,
} from "@material-ui/core";
import CancelAcceptButtons from "../../Common/CancelAcceptForm";
import t from "../../../languages/pl";
import { themeTypeToBool } from '../../../utils/helpers';
import ConfirmationDialog from "../../Common/ConfirmationDialog";
import AssignCarsDialog from '../../Common/AssignCarsDialog';
import AssignedCarsList from '../../Common/AssignedCarsList';

const useStyles = theme => ({
    row: {
        display: 'flex',
        alignItems: "center",
        margin: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        paddingLeft: theme.spacing(2)
    },
    label: {
        color: themeTypeToBool(theme.palette.type) ? "#000" : "#FAFAFA",
    },
    textfield: {
        margin: theme.spacing(1)
    },
    tableContainer: {
        maxHeight: "55vh"
    },
    existingGroup: {
        color: "red",
        fontWeight: "bold",
        fontSize: "0.875rem",
        marginBottom: theme.spacing(2),
        marginLeft: theme.spacing(2)
    },
});


const CarsInGroupDialog = props => {
    const { classes, open, onClose, onDelete, onSubmit, onCarAssignSubmit, group, cars = [], groupsNames } = props;
    const [deleteDialogOpen, setDeleteDialog] = useState(false);
    const [groupName, setGroupName] = useState("");
    const [groupDescription, setGroupDescription] = useState("");
    const [assignOpen, setAssignOpen] = useState(false);
    const [exisingGroupName, setExisingGroupName] = useState(false);

    useEffect(() => {
        const groupNamesWithoutSelectedGroup = groupsNames.filter(name => name !== group.grupa_nazwa);
        setExisingGroupName(groupNamesWithoutSelectedGroup.includes(groupName));
    }, [groupName]);

    useEffect(() => {
        setGroupName(group.grupa_nazwa);
        setGroupDescription(group.grupa_opis);
    }, [group]);

    const handleGroupDelete = () => {
        if(onDelete && group)
            onDelete(group.grupa_id);
        setDeleteDialog(false);
        onClose();
    };

    const handleSubmit = () => {
        if(onSubmit)
            onSubmit(group.grupa_id, groupName, groupDescription);
    };

    const handleCarsAssignSubmit = (carIds) => {
        if(onCarAssignSubmit)
            onCarAssignSubmit(group.grupa_id, carIds, group.grupa_nazwa);
        setAssignOpen(false);
    };

    return (
        <React.Fragment>
            <Dialog
                open={open}
                onClose={onClose}
                fullWidth
                maxWidth="lg"
            >
                <DialogTitle>
                    {t.groupDetails}&nbsp;{group.grupa_nazwa.toUpperCase()}
                </DialogTitle>
                <DialogContent>
                    <div className={classes.row}>
                        <TextField
                            label={t.name}
                            className={classes.textfield}
                            InputLabelProps={{
                                classes: {root: classes.label}
                            }}
                            disabled={!group.usuwalna}
                            defaultValue={groupName}
                            onChange={(e) => setGroupName(e.target.value)}
                        />
                        <TextField
                            label={t.description}
                            className={classes.textfield}
                            InputLabelProps={{
                                classes: { root: classes.label }
                            }}
                            defaultValue={groupDescription}
                            onChange={(e) => setGroupDescription(e.target.value)}
                        />
                    </div>
                    {exisingGroupName
                        ? <div className={classes.existingGroup}>{t.groupWithThatNameExists}</div>
                        : null
                    }
                        <AssignedCarsList data={cars} />
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => setAssignOpen(true)}
                    >
                        {t.assignCars}
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        disabled={!group.usuwalna}
                        onClick={() => setDeleteDialog(true)}
                    >
                        {t.deleteGroup}
                    </Button>
                    <CancelAcceptButtons
                        onCancel={onClose}
                        onSubmit={handleSubmit}
                        disableSubmit={exisingGroupName}
                    />
                </DialogActions>
            </Dialog>

            <ConfirmationDialog
                open={deleteDialogOpen}
                onClose={() => setDeleteDialog(false)}
                id={group}
                onSubmit={handleGroupDelete}
                action={t.deleteGroupConfirmation}
            />
            {
                assignOpen
                &&
                <AssignCarsDialog
                open={assignOpen}
                onClose={() => setAssignOpen(false)}
                carsInGroup={cars}
                title={t.toGroup + " " +  group.grupa_nazwa.toUpperCase()}
                onSubmit={handleCarsAssignSubmit}
            />
            }
        </React.Fragment>
    );
};

CarsInGroupDialog.propTypes = {
    classes: PropTypes.object,
    open: PropTypes.bool,
    group: PropTypes.object,
    cars: PropTypes.array,
    onClose: PropTypes.func,
    onDelete: PropTypes.func,
    onSubmit: PropTypes.func,
    onCarAssignSubmit: PropTypes.func,
    groupsNames: PropTypes.array,
};

export default withStyles(useStyles)(CarsInGroupDialog);
